import clsx from 'clsx';
import PropTypes from 'prop-types';
import { forwardRef, useCallback, useState } from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = forwardRef(function MyInput(props, ref)  {
  const [play, setPlay] = useState(false);
  const isCard = props.variant === 'card';
  const [height, setHeight] = useState(props.height);
  const [isDefaultImageHidden, setIsDefaultImageHidden] = useState(false);
  const onInit = useCallback(() => {
    props.onReady();
    setHeight('100%');
  }, []);
  return (
    <div
      className={`relative w-full ${props.containerClassName}`}
      style={{ paddingTop: props.paddingTop, ...props.containerStyle }}
    >
      {!!props.siblingComponent && props.siblingComponent}
      {props.isDefaultImage && !isDefaultImageHidden && (
        <img
          src={props.thumbnail}
          className="absolute top-0 left-0 h-full cursor-pointer w-full"
          alt="video thumbnail"
          onClick={() => {
            setPlay(true);
            props.stopInterval();
            setIsDefaultImageHidden(true);
          }}
        />
      )}
      {(!props.isDefaultImage || isDefaultImageHidden) && (
        <ReactPlayer
          ref={ref}
          id={props.id}
          height={height}
          width="100%"
          light={props.light ?? true}
          className={clsx([props.className, 'absolute top-0 left-0 h-full'])}
          playing={play}
          onReady={() => onInit()}
          onPause={() => {setPlay(false); props.startInterval();}}
          onPlay={() => {setPlay(true);props.stopInterval();}}
          onClickPreview={() => setPlay(true)}
          controls
          playIcon={
            <img
              src={props.playIcon}
              alt="YouTube play"
              className="w-12 h-12 transform hover:scale-110 transition-transform"
              style={{ marginTop: isCard ? '0' : '56.25%' }}
            />
          }
          url={props.url}
          config={{
            file: { attributes: { controlsList: 'nodownload' } },
            youtube: { rel: 0 }
          }}
          onContextMenu={(e) => e.preventDefault()}
        />
      )}
    </div>
  );
});

export default VideoPlayer;

VideoPlayer.propTypes = {
  onReady: PropTypes.func,
  url: PropTypes.string.isRequired,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  playIcon: PropTypes.string,
  containerStyle: PropTypes.object,
  id: PropTypes.string.isRequired,
  paddingTop: PropTypes.string,
  height: PropTypes.string,
  light: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  siblingComponent: PropTypes.element,
  variant: PropTypes.oneOf(['full', 'card']),
  stopInterval : PropTypes.func,
  startInterval : PropTypes.func
};

VideoPlayer.defaultProps = {
  onReady: () => {},
  startInterval : ()=>{},
  stopInterval : () =>{},
  className: '',
  containerClassName: '',
  playIcon: '/images/icons/play-icon.svg',
  containerStyle: {},
  height: 'inherit',
  light: true,
  paddingTop: '56.25%',
  siblingComponent: null,
  variant: 'full',
  isDefaultImage: false,
  thumbnail: null
};
